export default __webpack_public_path__ + "static/media/litSample.8f434649.png";